<ion-row class="p-10">
  <ion-col size>
    <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
    <div class="formLabelSemiBoldfs16 mb-5">Change Needed </div>
  </ion-col>
  
  <ion-col size="auto" class="text-right">
    <img class="cp" src="././assets/icon/close_icon.png" (click)="closeDialog()">
  </ion-col>
</ion-row>

 <mat-dialog-content class="p-0">
<div class="form-container">
  <div class="cardLayout">
    <!-- <ion-row>
      <ion-col size="4"> -->
        <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
        <div class="formLabelSemiBoldfs16 mb-5" [style.color]="buttonColorName">Old Details</div>
      <!-- </ion-col>
    </ion-row> -->
   
      <!-- authority-form.component.html -->
      <form [formGroup]="changeNeededForm">
        <ion-row>
          <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">CTC PA<span class="red-cl">*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput formControlName="oldctc" readonly />
            </mat-form-field>
            <mat-error *ngIf="hasError('oldctc', 'required')">ctc is required</mat-error>
          </ion-col>
          
          
          <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Band<span class="red-cl">*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput formControlName="oldBand" readonly />
            </mat-form-field>
            <mat-error *ngIf="hasError('oldBand', 'required')">band is required</mat-error>
          </ion-col>
          
          <!-- Limit of Reimbursement -->
          <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Grade<span class="red-cl">*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput formControlName="oldGrade" readonly />
            </mat-form-field>
            <mat-error *ngIf="hasError('oldGrade', 'required')">grade is required</mat-error>
          </ion-col>
          
          <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">
              Designation<span class="red-cl">&nbsp;*</span>
            </div>
            
            
            
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput formControlName="oldDesignation" readonly />
            </mat-form-field>
            <mat-error *ngIf="hasError('oldDesignation', 'required')">designation is required</mat-error>
            
            
            
          </ion-col>
          <ion-col size="12">
            <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
            <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;" [style.color]="buttonColorName">New Details
            </div>
          </ion-col>
          <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">CTC PA<span class="red-cl">*</span></div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput type="number" formControlName="newctc" style="color: black !important;"
              (keypress)="allowOnlyNumbers($event)" [max]="100000000" />
            </mat-form-field>
            <mat-error *ngIf="hasError('newctc', 'required')">
              ctc is required
            </mat-error>
            <mat-error *ngIf="hasError('newctc','max')">
              Value must not exceed 10 Cr
            </mat-error>
            <mat-error *ngIf="hasError('newctc','pattern') && !hasError('newctc','required')">
              Special characters not allowed
            </mat-error>
            
            
          </ion-col>
          <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
            <div class="formLabelRegularfs16  mb-5">Band<span class="red-cl">&nbsp;*</span></div>
            <ng-select [addTag]="true" placeholder="Select Band" formControlName="newBand">
              <ng-option [value]="item.id" *ngFor="let item of getListOfBandNameOfComp">{{item.name}}</ng-option>
            </ng-select>
            <mat-error *ngIf="hasError('newBand', 'required')">band is required</mat-error>
          </ion-col>
          
          <!-- Grade -->
          <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Grade<span class="red-cl">&nbsp;*</span></div>
            <ng-select [addTag]="true" placeholder="Select Grade" formControlName="newgrade">
              <ng-option [value]="item.id" *ngFor="let item of getListOfGradeNameOfComp">{{item.name}}</ng-option>
            </ng-select>
            <mat-error *ngIf="hasError('newgrade', 'required')">Grade
              is required</mat-error>
            </ion-col>
            
            <!-- Designation -->
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Designation<span class="red-cl">&nbsp;*</span></div>
              <ng-select [addTag]="true" placeholder="Select Designation" formControlName="newDesignation">
                <ng-option [value]="item.id" *ngFor="let item of getListOfDesignationsOfComp">{{item.name}}</ng-option>
              </ng-select>
              <mat-error *ngIf="hasError('newDesignation', 'required')">designation is required</mat-error>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12" class="text-right mt-10">
              <button class="back_btn fs-14 fs_12ForMobile" (click)="closeDialog()">Cancel</button>
              <button type="button" class="add_btn fs-14 fs_12ForMobile ml-10" [style.background-color]="buttonColorName"
              (click)="saveChanges()" [hidden]="tabName === 'ReportTab'">
              save
            </button>
          </ion-col>
        </ion-row>
      </form>
    </div>
  </div>
</mat-dialog-content>